
    <p-chart type="bar" [data]="data" [options]="options" height="20rem"></p-chart>
